<template lang="pug">
	//- Запрос агента на подтверждение действия (удаление креатива / версии, отвязка от репозитория): действие выполняется только после нажатия кнопки подтверждения
	.ai-chat-message-content.ai-chat-confirm(:class="[message.options.status, getActionClass()]")
		.ai-chat-confirm-text
			i.fa.fa-exclamation-triangle
			span {{message.message}}
		.ai-chat-confirm-actions(v-if="message.options.status === 'pending'")
			button.btn.btn-sm(type="button" :class="message.options.confirmClass || 'btn-danger'" :disabled="confirming" v-on:click="answer(true)")
				i.fa(:class="confirming ? 'fa-spinner fa-spin' : (message.options.confirmIcon || 'fa-trash')")
				span {{message.options.confirmLabel || 'Delete'}}
			button.btn.btn-sm(v-if="message.options.extraSteps" type="button" :class="message.options.confirmClass || 'btn-danger'" :disabled="confirming" v-on:click="answer(true, message.options.extraSteps)")
				i.fa(:class="message.options.confirmIcon")
				span Continue {{message.options.extraSteps}} iterations
			button.btn.btn-ghost-light.btn-sm(type="button" :disabled="confirming" v-on:click="answer(false)")
				span Cancel
		.ai-chat-confirm-status(v-else) {{getStatusText()}}
</template>

<script>
	export default {
		name: "AIAgentMessageConfirm",
		// confirming - ответ на этот запрос уже отправлен на сервер (кнопки блокируются до ответа сервера)
		props: ['message', 'confirming'],
		methods: {
			// Ответ пользователя (confirmed = true - подтверждение, false - Cancel) отправляет на сервер компонент чата
			answer(confirmed, steps = 0) {

				this.$emit('answer', this.message, confirmed, steps);

			},
			// Класс по действию подтверждения: импорт присланных файлов оформляем жёлтым (в отличие от опасных действий - красных)
			getActionClass() {

				return this.message.options.action ? `action-${this.message.options.action}` : '';

			},
			getStatusText() {

				if (this.message.options.status === 'confirmed') return this.message.options.confirmedText || 'Deleted';
				if (this.message.options.status === 'cancelled') return 'Cancelled';

				return 'Failed';

			}
		}
	}
</script>

<style lang="sass">

	.ai-chat
		.ai-chat-history
			.ai-chat-message
				// Запрос подтверждения удаления креатива / версии
				&.confirm
					.ai-chat-confirm
						background-color: rgba(248,108,107,0.12)
						border: 1px solid #f86c6b

						// Импорт присланных файлов (не удаление) - жёлтый, а не красный
						&.pending.action-import-attachments
							background-color: rgba(255,193,7,0.12)
							border-color: #ffc107

							.ai-chat-confirm-text i.fa
								color: #ffc107

						&.confirmed, &.cancelled, &.failed
							border-color: #23282c
							background-color: rgba(255,255,255,0.08)

					.ai-chat-confirm-text
						display: flex
						flex-direction: row
						align-items: baseline
						gap: 8px

						i.fa
							color: #f86c6b

					.ai-chat-confirm-actions
						display: flex
						flex-direction: row
						gap: 8px
						margin-top: 8px

						.btn i.fa
							margin-right: 6px

					.ai-chat-confirm-status
						margin-top: 4px
						font-size: 12px
						color: #73818f
						font-style: italic

</style>
